import { FormEvent, useState } from 'react';
import { Link } from 'react-router-dom';
import { api, ErroApi } from '../lib/api';
import { Alerta, Botao, Campo, Cartao } from '../componentes/Interface';

export default function EsqueciSenha() {
  const [email, setEmail] = useState('');
  const [enviando, setEnviando] = useState(false);
  const [pronto, setPronto] = useState<string | null>(null);
  const [erro, setErro] = useState<string | null>(null);

  async function enviar(e: FormEvent) {
    e.preventDefault();
    setErro(null);
    setEnviando(true);
    try {
      const r = await api<{ mensagem: string }>('/auth/esqueci', {
        method: 'POST',
        body: JSON.stringify({ email }),
      });
      setPronto(r.mensagem);
    } catch (e) {
      setErro(e instanceof ErroApi ? e.message : 'Não consegui enviar o pedido.');
    } finally {
      setEnviando(false);
    }
  }

  return (
    <div className="flex min-h-full items-center justify-center bg-fundo px-4 py-12">
      <div className="w-full max-w-sm">
        <div className="mb-6 flex flex-col items-center">
          <img src="/logo-fundo.png" alt="Sara Osasco" className="h-20 w-20 rounded-2xl object-cover shadow-cartao" />
          <h1 className="mt-3 text-xl font-semibold text-tinta-900">Esqueci minha senha</h1>
        </div>
        <Cartao>
          {pronto ? (
            <div className="space-y-4">
              <Alerta tipo="ok">{pronto}</Alerta>
              <p className="text-sm text-tinta-600">
                Se voce nao receber o link, fale com o administrador — ele pode definir uma
                senha nova para voce.
              </p>
              <Link to="/login" className="block text-center text-sm text-tinta-900 hover:underline">
                Voltar para o login
              </Link>
            </div>
          ) : (
            <form onSubmit={enviar} className="space-y-4">
              {erro && <Alerta>{erro}</Alerta>}
              <Campo
                rotulo="Seu e-mail"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <Botao type="submit" carregando={enviando} className="w-full">
                Enviar link
              </Botao>
              <Link to="/login" className="block text-center text-sm text-tinta-900 hover:underline">
                Voltar
              </Link>
            </form>
          )}
        </Cartao>
      </div>
    </div>
  );
}
